import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import func from "../../../services/functions";
import { bankStatusEmployee, compareStatus } from "../OpenBankingUtils";
const bigDecimal = require("js-big-decimal");
const { round } = func;

const PayrollTotals = ({ payroll, setPayroll }) => {
  const { t } = useTranslation("translations");

  const total = useMemo(() => {
    return payroll.salaryRecords.reduce(
      (acc, inv) => bigDecimal.add(acc, inv.amount),
      "0"
    );
  }, [payroll.salaryRecords]);

  const pendingData = useMemo(() => {
    const pending = payroll.salaryRecords.filter(
      (record) => compareStatus(record.bankStatus, bankStatusEmployee.WAITING)
    );
    return {
      count: pending.length,
      amount: pending.reduce(
        (acc, record) => bigDecimal.add(acc, record.amount.toString()),
        "0"
      ),
    };
  }, [payroll.salaryRecords]);

  const rejectedData = useMemo(() => {
    const rejected = payroll.salaryRecords.filter(
      (record) => compareStatus(record.bankStatus, bankStatusEmployee.FAILED)
    );
    return {
      count: rejected.length,
      amount: rejected.reduce(
        (acc, record) => bigDecimal.add(acc, record.amount.toString()),
        "0"
      ),
    };
  }, [payroll.salaryRecords]);

  const confirmedData = useMemo(() => {
    const confirmed = payroll.salaryRecords.filter(
      (record) => compareStatus(record.bankStatus, bankStatusEmployee.SUCCESS)
    );
    return {
      count: confirmed.length,
      amount: confirmed.reduce(
        (acc, record) => bigDecimal.add(acc, record.amount.toString()),
        "0"
      ),
    };
  }, [payroll.salaryRecords]);

  return (
    <>
          <div className="d-flex flex-row align-items-start" style={{marginBottom:2}}>
        <div style={{ width: "55%" }}/> 
        <div style={{ width: "35%" }}>
          <span>
            <strong>{t("payRoll.numberOfEmployees")}</strong>
          </span>
        </div>
        <div style={{ width: "10%", textAlign: "right",marginRight:10 }}>
          <span>
            <strong>{t("payRoll.amount")}</strong>
          </span>
        </div>
      </div>
      <div className="payment-totals-divider mt-0"/>
      <div className="d-flex flex-row align-items-start mb-2 mt-3">
        <div style={{ width: "60%" }}>
          <span>
            <strong>{t("payRoll.totalToPay")} (Lek)</strong>
          </span>
        </div>
        <div style={{ width: "10%", textAlign: "center" }}>
          <span>{payroll.salaryRecords?.length || 0}</span>
        </div>
        <div style={{ width: "30%", textAlign: "right" }}>
          <span>
            <strong>{func.getFormattedMoneyValue(total)}</strong>
          </span>
        </div>
      </div>

      <div className="d-flex flex-row align-items-start mb-3">
        <div style={{ width: "60%" }}>
          <span>{t("payRoll.processingFees")}</span>
        </div>
        <div style={{ width: "10%" }}></div>
        <div style={{ width: "30%", textAlign: "right" }}>
          <span>{func.getFormattedMoneyValue(payroll?.processingFees ?? "0")}</span>
        </div>
      </div>

      <div className="d-flex flex-row align-items-start mb-2">
        <div style={{ width: "60%" }}>
          <span>
            <strong>{t("payRoll.totalConfirmedByBank")}</strong>
          </span>
        </div>
        <div style={{ width: "10%", textAlign: "center" }}>
          <span>{confirmedData.count}</span>
        </div>
        <div style={{ width: "30%", textAlign: "right" }}>
          <span>
            <strong>{func.getFormattedMoneyValue(confirmedData.amount)}</strong>
          </span>
        </div>
      </div>

      <div className="d-flex flex-row align-items-start mb-1">
        <div style={{ width: "60%" }}>
          <span>{t("payRoll.rejected")} (Lek)</span>
        </div>
        <div style={{ width: "10%", textAlign: "center" }}>
          <span>{rejectedData.count}</span>
        </div>
        <div style={{ width: "30%", textAlign: "right" }}>
          <span>{func.getFormattedMoneyValue(rejectedData.amount)}</span>
        </div>
      </div>

      <div className="d-flex flex-row align-items-start">
        <div style={{ width: "60%" }}>
          <span>{t("payRoll.pending")} (Lek)</span>
        </div>
        <div style={{ width: "10%", textAlign: "center" }}>
          <span>{pendingData.count}</span>
        </div>
        <div style={{ width: "30%", textAlign: "right" }}>
          <span>{func.getFormattedMoneyValue(pendingData.amount)}</span>
        </div>
      </div>
    </>
  );
};

export default PayrollTotals;